'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { earnSummaryBunja, isEarnCardCurrency } from '@flipster/features/src/shared/earn/state';
import { FormattedMessage } from '@flipster/i18n';
import { css } from '@flipster/styled-system/css';
import { stack, vstack } from '@flipster/styled-system/patterns';

import { InactiveAprCard } from './inactive-apr-card';

export const BeforeParticipationEarnAprSection = () => {
  const { earnSummaryAtom } = useBunja(earnSummaryBunja);
  const earnSummary = useAtomValue(earnSummaryAtom);

  return (
    <section className={stack({ gap: 20 })}>
      <div className={stack({ gap: 4 })}>
        <p className={css({ textStyle: 'Title/M', color: 'content.default.level-5' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Deposit_and_start_earning' />
        </p>
        <p className={css({ textStyle: 'Text/M/Regular', color: 'content.default.level-2' })}>
          <FormattedMessage id='Autogen_common.r251126.s_Earn_and_trade_seamlessly_Grow_your_balance_while_you_trade' />
        </p>
      </div>
      <div className={vstack({ alignItems: 'stretch', gap: 10 })}>
        {earnSummary?.currencies
          .filter((c) => isEarnCardCurrency(c.currency))
          .map((c) => (
            <InactiveAprCard key={c.currency} currency={c.currency} />
          ))}
      </div>
    </section>
  );
};
